import {PROTECTED_RANGES as PREFIX, DEFAULT_PER_PAGE_MEDIUM} from "const";
import {PROTECTED_RANGES_SET_LOADING, PROTECTED_RANGES_SET_LIST} from "actions/actionTypes";

const initialState = {
    list: [],
    loading: true,
    page: 1,
    perPage: +localStorage.getItem(PREFIX + "_per_page") || DEFAULT_PER_PAGE_MEDIUM,
    count: 0
};

const handlers = {
    [PROTECTED_RANGES_SET_LOADING]: (state, {payload}) => ({...state, loading: payload}),
    [PROTECTED_RANGES_SET_LIST]: (state, {payload: {list, page, perPage, count}}) => {
        return {
            ...state,
            list: list,
            page, 
            perPage,
            count,
            loading: false,
        }
    },
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};